var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    clipPath: "url(#clip0_3543_149788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 4.88889H11.1111V1.33333C11.1111 0.597778 10.5133 0 9.77778 0H0V9.77778C0 10.5133 0.595556 11.1111 1.33333 11.1111H4.88889V14.6667C4.88889 15.4022 5.48444 16 6.22222 16H14.6667C15.4022 16 16 15.4022 16 14.6667V6.22222C16 5.48667 15.4022 4.88889 14.6667 4.88889ZM1.33333 10.1111C1.14889 10.1111 1 9.96222 1 9.77778V1H9.77778C9.96222 1 10.1111 1.14889 10.1111 1.33333V4.88889H4.88889V10.1111H1.33333ZM5.88889 5.88889H10.1111V9.77778C10.1111 9.96222 9.96222 10.1111 9.77778 10.1111H5.88889V5.88889ZM15 14.6667C15 14.8511 14.8511 15 14.6667 15H6.22222C6.03778 15 5.88889 14.8511 5.88889 14.6667V11.1111H9.77778C10.5133 11.1111 11.1111 10.5133 11.1111 9.77778V5.88889H14.6667C14.8511 5.88889 15 6.03778 15 6.22222V14.6667Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3543_149788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c31c7f223f3492b623c4582050cb265f.svg";
export { ForwardRef as ReactComponent };